<div class="info-page how-it-works-page">
  <header class="info-hero">
    <p class="info-kicker">Playbook</p>
    <h1 class="info-heading">How It Works</h1>
    <p class="info-sub">Hosts list seats. Buyers grab a chance. One random winner walks away with the prize.</p>
  </header>

  <article class="info-panel">
    <div class="info-block-title">
      <span class="info-icon info-icon--gold">1</span>
      Overview
    </div>
    <p class="info-copy">
      Sellers list items (like a product review experience) and offer a fixed number of <strong>seats</strong>. Buyers purchase seats for a chance to be selected when the review goes live. Once all seats are sold, the review is played and a random winner is chosen from the sold seats.
    </p>
  </article>

  <div class="hiw-compare">
    <section class="hiw-col hiw-col--host">
      <header class="hiw-col-head">
        <span class="info-icon info-icon--wine">H</span>
        <div>
          <h2>For Hosts</h2>
          <p>List your products and manage reviews</p>
        </div>
      </header>
      <article class="hiw-step">
        <h3>1. Create Your Webinar</h3>
        <p>Sign up as a host and create a webinar listing. Add product details including:</p>
        <ul>
          <li>Product title and description</li>
          <li>Product images (up to 8 images)</li>
          <li>Product review video (30 seconds to 3 minutes)</li>
          <li>Number of seats available</li>
          <li>Price per seat</li>
          <li>Scheduled date and time for the review</li>
          <li>Maximum seats allowed per buyer</li>
        </ul>
      </article>
      <article class="hiw-step">
        <h3>2. Publish &amp; Share</h3>
        <p>Once published, your webinar listing becomes publicly visible. No login is required for viewers to browse. Share your webinar link on social media, email, or any platform to attract buyers.</p>
      </article>
      <article class="hiw-step">
        <h3>3. Track Sales in Real-Time</h3>
        <p>Monitor seat sales through your host dashboard. Watch as seats are purchased in real-time. When all seats are sold, the webinar is automatically locked in for the scheduled review time.</p>
      </article>
      <article class="hiw-step">
        <h3>4. Run the Review</h3>
        <p>On the scheduled date and time, access your webinar run dashboard. The review video will be played for all seat purchasers. The system automatically selects a random winner after the review completes.</p>
      </article>
      <article class="hiw-step">
        <h3>5. Manage Shipments &amp; Payments</h3>
        <p>After the winner is selected, ship the product to the winning buyer. Track all shipments and view payment settlements through your host portal. Platform charges are automatically calculated and deducted.</p>
      </article>
    </section>

    <section class="hiw-col hiw-col--buyer">
      <header class="hiw-col-head">
        <span class="info-icon info-icon--teal">B</span>
        <div>
          <h2>For Buyers</h2>
          <p>Discover products and win giveaways</p>
        </div>
      </header>
      <article class="hiw-step">
        <h3>1. Browse &amp; Discover</h3>
        <p>Explore available webinars and product reviews. View product details, images, and pricing without needing to log in. Find products that interest you and check seat availability.</p>
      </article>
      <article class="hiw-step">
        <h3>2. Create Account &amp; Purchase Seats</h3>
        <p>When ready to purchase, create a free account. Select one or more available seats (up to the maximum allowed per webinar). Add seats to your cart and proceed to checkout. Complete payment securely through the payment gateway.</p>
      </article>
      <article class="hiw-step">
        <h3>3. Wait for All Seats to Sell</h3>
        <p>Once you've purchased your seat(s), wait for all remaining seats to be sold. You'll receive notifications when the review is about to begin. The review starts 10 minutes after the final seat is purchased.</p>
      </article>
      <article class="hiw-step">
        <h3>4. Join the Live Review</h3>
        <p>Access the webinar run page using the provided link. Watch the product review video live with other seat purchasers. The review typically lasts 30 seconds to 3 minutes.</p>
      </article>
      <article class="hiw-step">
        <h3>5. Winner Selection &amp; Giveaway</h3>
        <p>After the review completes, a random winner is selected from all purchased seats using a Random Number Generator (RNG). If you win, the product will be shipped to your registered shipping address. Check your purchase history to track your seats and any wins.</p>
      </article>
    </section>
  </div>

  <article class="info-panel">
    <div class="info-block-title">
        <span class="info-icon info-icon--purple">R</span>
      Winner Selection Process
    </div>
    <ul>
      <li><strong>Trigger:</strong> Winner selection only occurs <strong>after all seats are sold</strong> and the review video has been played.</li>
      <li><strong>Method:</strong> A <strong>Random Number Generator (RNG)</strong> selects exactly one winning seat from the full set of sold seats. The selection is completely automated and transparent.</li>
      <li><strong>Result:</strong> The winning seat number and buyer information are displayed on the webinar page and recorded in the webinar's history. The winner is notified and the product is shipped to their registered address.</li>
    </ul>
  </article>

  <article class="info-panel">
    <div class="info-block-title">
      <span class="info-icon info-icon--coral">✓</span>
      Key Rules &amp; Safeguards
    </div>
    <ul>
      <li><strong>One winner per webinar:</strong> Exactly one winning seat is drawn per webinar; ties are impossible.</li>
      <li><strong>Seat limits:</strong> Sellers can set a maximum number of seats that each buyer can purchase for a webinar to ensure fair distribution.</li>
      <li><strong>Compliance:</strong> All listings must follow platform policies and local regulations. Prohibited items or false claims are not allowed.</li>
      <li><strong>Privacy:</strong> We show only minimal buyer information (e.g., username/handle) when announcing a winner to protect privacy.</li>
      <li><strong>Payment security:</strong> All transactions are processed through secure payment gateways. Platform charges are transparent and automatically calculated.</li>
    </ul>
  </article>
</div>
